import hyperdom from 'hyperdom'
import pluralize from 'pluralize'
import BasePaymentMethod from '../methods/basePaymentMethod.jsx'
import PlaceOnHoldPaymentMethod from '../methods/onHold.jsx'
import formats from 'root-packages/dates/formats.js'
import formatDate from 'root-packages/dates/formatDate.js'
import LocalDate from '@booking-services/localDate'

export default class OnHold extends BasePaymentMethod {
  constructor (payment) {
    super(payment)

    const method = new PlaceOnHoldPaymentMethod(payment)
    this.paymentMethods = {
      selected: method,
      eligible: [method],
    }
  }

  eligible () {
    return this.payment.booking.booking.paymentOptions.placeBookingOnHold
  }

  amount () {
    return 0
  }

  onHoldDueDateDiscounts () {
    const breakdown = this.payment.priceBreakdown()
    const discounts = breakdown.discounts.promotions.applied.concat(breakdown.discounts.epd ? [breakdown.discounts.epd] : [])
    const discountsDates = discounts.flatMap(d => ([
      d.paymentBy && d.paymentBy.date,
      d.depositPaymentBy && d.depositPaymentBy.date,
    ])).filter(Boolean)
    const earliestDiscountPaymentDate = discountsDates.length > 0
      ? discountsDates.sort((a, b) => a - b)[0]
      : null
    const dueDate = earliestDiscountPaymentDate && earliestDiscountPaymentDate <
      this.payment.booking.booking.paymentOptions.placeBookingOnHold.dueDate
      ? earliestDiscountPaymentDate
      : this.payment.booking.booking.paymentOptions.placeBookingOnHold.dueDate
    return dueDate
  }

  getDaysToPayText () {
    const currentDate = new LocalDate()
    let daysToPay = currentDate.differenceInDays(this.onHoldDueDateDiscounts())

    if (currentDate.getTimezoneOffset() > this.onHoldDueDateDiscounts().getTimezoneOffset()) {
      daysToPay++
    }

    return `${daysToPay} ${pluralize('day', daysToPay)}`
  }

  render () {
    return <div class="u-margin-bottom-small">
      <label data-test={'payment-type-onhold'} class={['o-choice-item payment-options__item', {'-selected': this.payment.paymentOption() === this}]}>
        <input type='radio' class='o-choice-item__radio' value={this}
          binding={[this.payment.paymentOptions, 'selected']}
          name='payment-type' />
        <div class='o-choice-item__content payment-option__container'>
          <div>
            <div className='payment-option__title'>
              <div className='payment-option__title__header'>Save & hold my booking for {this.getDaysToPayText()}</div>
              {this.renderOnHoldSubTitle()}
            </div>
          </div>
        </div>
        <div className={['payment-option__methods-container', {'show-expanded': this.payment.paymentOption() === this}]}>
          {this.payment.paymentOption() === this ? this.paymentMethods.selected.renderTermsAndConditions() : ''}
          {this.payment.paymentOption() === this ? this.paymentMethods.selected.renderPaymentSummary() : ''}
        </div>
      </label>
    </div>
  }

  renderOnHoldSubTitle () {
    return <div>We can keep your booking FREE of charge up to
      {'\u00A0' + formatDate(this.onHoldDueDateDiscounts(), formats.dayMonthYear)} </div>
  }
}
